// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__1k9YB","hideOnTablet":"styles_hideOnTablet__2Avtw","hideOnMobile":"styles_hideOnMobile__3WNW0","cards":"styles_cards__3jErI"};